var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _circle2, _path8, _path9, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUpSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 166,
    viewBox: "0 0 266 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0686 9.64995C92.0686 13.8274 98.7644 17.214 94.105 17.214C89.4456 17.214 85.6685 13.8274 85.6685 9.64995C85.6685 5.47246 89.4456 2.08594 94.105 2.08594C98.7644 2.08594 92.0686 5.47246 92.0686 9.64995Z",
    fill: "#FE964A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.23 6L159.362 9.4844H163.026L160.062 11.6379L161.194 15.1223L158.23 12.9688L155.266 15.1223L156.398 11.6379L153.434 9.4844H157.098L158.23 6Z",
    fill: "#FE964A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5646 77.1071C46.6599 76.0659 44.6108 76.1482 42.3913 76.6636C41.7138 79.3755 42.1563 82.5958 44.8917 83.0762C46.4561 83.3509 47.7913 83.2018 48.7161 82.0325C49.9157 80.5156 48.9041 78.6486 47.5646 77.1071Z",
    fill: "#E22323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3783 79.6545C34.3783 79.6545 45.1264 74.3013 47.5646 77.1071C48.9041 78.6486 49.9157 80.5156 48.7161 82.0325C47.7913 83.2018 46.4561 83.3509 44.8917 83.0762C41.5789 82.4944 41.6292 77.8939 42.959 75.0448C44.7951 71.1109 54.5416 73.4329 54.5416 73.4329",
    stroke: "#E22323",
    strokeWidth: 2.01707
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 229.217,
    cy: 74.2933,
    r: 5.88312,
    fill: "#FFEDEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0474 135.992L56.8844 128.772L62.7199 132.472L63.3851 126.415L68.7079 130.082L70.3656 123.534",
    stroke: "#87B7DB",
    strokeWidth: 1.68089
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.301 21.9252C193.301 21.9252 192.482 17.0644 194.831 16.0956C196.803 15.2817 198.514 18.8811 200.135 17.5761C201.777 16.2543 197.678 14.1603 199.013 12.5794C200.418 10.9155 204.929 12.5794 204.929 12.5794",
    stroke: "#87B7DB",
    strokeWidth: 2.01707
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0123 29.7967L40.8511 20.6715L51.7318 26.0882L49.0123 29.7967Z",
    fill: "#87B7DB",
    stroke: "#87B7DB",
    strokeWidth: 3.7459
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.346,
    cy: 94.3124,
    r: 2.52134,
    fill: "#FFEDEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.032 128.338C200.945 128.43 201.798 128.148 202.499 127.81C203.088 127.526 203.64 127.165 204.074 126.88C204.155 126.828 204.232 126.777 204.304 126.731C204.346 126.704 204.386 126.678 204.424 126.654C204.116 129.326 201.976 131.133 199.773 130.911C197.57 130.689 195.833 128.492 196.063 125.812C196.096 125.844 196.13 125.877 196.166 125.912C196.227 125.972 196.292 126.036 196.361 126.104C196.73 126.469 197.199 126.933 197.719 127.328C198.339 127.8 199.119 128.246 200.032 128.338Z",
    fill: "#87B7DB",
    stroke: "#87B7DB",
    strokeWidth: 1.68089
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.11 38.9922L210.997 44.7995H217.103L212.163 48.3887L214.05 54.196L209.11 50.6069L204.17 54.196L206.057 48.3887L201.117 44.7995H207.223L209.11 38.9922Z",
    fill: "#E22323"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.7998,
    y: 25.8223,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#1B2336"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_270_4322)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.8,
    y: 45.8223,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.684 68.6884C144.172 69.1765 144.172 69.968 143.684 70.4561L131.184 82.9561C130.696 83.4443 129.904 83.4443 129.416 82.9561L123.166 76.7061C122.678 76.218 122.678 75.4265 123.166 74.9384C123.654 74.4502 124.446 74.4502 124.934 74.9384L130.3 80.3045L141.916 68.6884C142.404 68.2002 143.196 68.2002 143.684 68.6884Z",
    fill: "#111827"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_270_4322",
    x: 62.7998,
    y: 25.8223,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_4322"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_4322",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpSuccess);
export default __webpack_public_path__ + "static/media/SignUpSuccess.fa5f7cff6b80740042ffc5590d517117.svg";
export { ForwardRef as ReactComponent };